<template>
  <ul class="audit-value" v-if="fields.length > 0">
    <li v-for="(field, i) in fields" :key="i">
      <span class="text-gray">{{ field.key }}</span> {{ field.value }}
    </li>
  </ul>
  <span v-else>{{ text }}</span>
</template>

<script>
import moment from 'moment';
import { translate } from '@/data/audit-values';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
const MAX_DEPTH = 4;

function isPlainObject(value) {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}

function formatScalar(value) {
  if (value === null || value === undefined || value === '') return '--';
  if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
  if (Array.isArray(value)) {
    return value.length === 0 ? '--' : value.map(item => formatScalar(item)).join(', ');
  }
  if (isPlainObject(value)) return JSON.stringify(value);
  if (typeof value === 'string' && ISO_DATE.test(value)) {
    return moment(value).format('L LT');
  }
  return String(value);
}

function flatten(value, prefix = '', out = [], depth = 0) {
  Object.keys(value).forEach((key) => {
    if (key === '_id') return;

    const item = value[key];
    const path = prefix ? `${prefix}.${key}` : key;

    if (item === null || item === undefined || item === '') return;

    if (isPlainObject(item) && depth < MAX_DEPTH) {
      flatten(item, path, out, depth + 1);
      return;
    }

    out.push({ key: path, value: formatScalar(item) });
  });

  return out;
}

export default {
  props: {
    value: {
      default: null,
    },
    entity: {
      type: String,
      default: null,
    },
    path: {
      type: String,
      default: null,
    },
  },
  computed: {
    fields() {
      if (isPlainObject(this.value)) {
        return flatten(this.value);
      }

      if (Array.isArray(this.value) && this.value.some(item => isPlainObject(item))) {
        return this.value.reduce((acc, item, i) => (
          isPlainObject(item) ? [...acc, ...flatten(item, String(i + 1))] : acc
        ), []);
      }

      return [];
    },
    text() {
      const translated = this.entity && this.path
        ? translate(this.entity, this.path, this.value)
        : null;

      return translated || formatScalar(this.value);
    },
  },
};
</script>

<style lang="scss">
  @import "./src/assets/scss/_variables.scss";
  .audit-value {
    list-style: none;
    margin: 0;
    li {
      margin: 0;
      span {
        margin-right: $unit-1;
      }
    }
  }
</style>
